export default {
	props:{
		id: String,
		name: String,
		value: [String, Number],
		options:{type:Array, default(){ return [];} },
		autocomplete: String,
		clearable: Boolean,
		errorMsg: String,
	},
	data(){
		return {
			innerValue: null,
			hintVisible: true,
			uniqueId: null,
		}
	},
	watch: {
		value:{
			immediate: true,
			handler(){ this.innerValue = this.value;},
		},
		innerValue:{
			immediate: true,
			handler(){
				//this.hintVisible = !this.innerValue;
				this.$emit('input', this.innerValue);
				this.$emit('change', this.innerValue);
			},
		},
	},
	computed:{
		hasValue(){
			return !!this.innerValue;
		},
		mainCssClass(){
			return ['input-radiogroup', this.clearable?'clearable':'', this.hasValue?'has-value':''];
		},
		elementId(){
			if(this.id) return this.id;
			if(this.name) return this.name.replaceAll('[','.').replaceAll(']','');
			if(this.uniqueId) return this.uniqueId;
			return '';
		}
	},
	methods: {
		onClear(){
			this.innerValue = '';
			this.$emit('clear');
		},
	},
	mounted() {
		this.uniqueId = this._uid?'id-'+this._uid:'';
	},
	template: `
<div :class="mainCssClass">
	<qit-input-radio 
			v-for="(v,i) in options" :key="i"
      :label="v.label" :name="name"
			:check-value="v.value" v-model="innerValue" :autocomplete="autocomplete"
	></qit-input-radio>
  <span v-if="hintVisible && errorMsg" class="hint error-msg" v-t="errorMsg"></span>
  <span v-if="clearable && hasValue" class="clear-btn" @click="onClear"></span>
</div>
`,
}
